// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimeInput.Common {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path fill="rgba(0, 0, 0, 0.5)" d="M320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64zM296 184L296 320C296 328 300 335.5 306.7 340L402.7 404C413.7 411.4 428.6 408.4 436 397.3C443.4 386.2 440.4 371.4 429.3 364L344 307.2L344 184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184z"/></svg>');
}

.TimeInput-Popover {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.TimeInput-Popover .popover-body {
  position: relative;
  padding: 0;
  overflow: hidden;
  border-radius: var(--bs-popover-border-radius);
}

.TimeInput-Interface {
  position: relative;
  display: flex;
  flex-grow: 1;
  gap: 1px;
  overflow: hidden;
  max-height: 50vh;
}
.TimeInput-Interface .TimeInput-Unit {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  scrollbar-gutter: stable;
}
.TimeInput-Interface .TimeInput-Unit .TimeInput-List {
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;
}
.TimeInput-Interface .TimeInput-Unit .TimeInput-List .TimeInput-Item .btn {
  width: 100%;
  border-width: 0;
  border-radius: 0;
  white-space: nowrap;
}
.TimeInput-Interface + .TimeInput-Controls {
  width: 100%;
}
.TimeInput-Interface + .TimeInput-Controls .btn {
  flex-grow: 1;
  border-radius: 0;
  border-width: 0;
  border-top: var(--bs-popover-border-width) solid var(--bs-popover-border-color) !important;
}
.TimeInput-Interface + .TimeInput-Controls .btn + .btn {
  border-left: var(--bs-popover-border-width) solid var(--bs-popover-border-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/common/TimeInput/styles.scss"],"names":[],"mappings":"AAAA;EACE,0mBAAA;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAEF;AADE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,8CAAA;AAGJ;;AAAA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;AAGF;AAFE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,+CAAA;EACA,wBAAA;AAIJ;AAHI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AAKN;AAHQ;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAKV;AAAE;EACE,WAAA;AAEJ;AADI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,0FAAA;AAGN;AAFM;EACE,2FAAA;AAIR","sourcesContent":[".TimeInput.Common {\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 640\"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path fill=\"rgba(0, 0, 0, 0.5)\" d=\"M320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64zM296 184L296 320C296 328 300 335.5 306.7 340L402.7 404C413.7 411.4 428.6 408.4 436 397.3C443.4 386.2 440.4 371.4 429.3 364L344 307.2L344 184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184z\"/></svg>');\n}\n.TimeInput-Popover {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  .popover-body {\n    position: relative;\n    padding: 0;\n    overflow: hidden;\n    border-radius: var(--bs-popover-border-radius);\n  }\n}\n.TimeInput-Interface {\n  position: relative;\n  display: flex;\n  flex-grow: 1;\n  gap: 1px;\n  overflow: hidden;\n  max-height: 50vh;\n  .TimeInput-Unit {\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n    scrollbar-gutter: stable;\n    .TimeInput-List {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      flex-grow: 1;\n      .TimeInput-Item {\n        .btn {\n          width: 100%;\n          border-width: 0;\n          border-radius: 0;\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n  + .TimeInput-Controls {\n    width: 100%;\n    .btn {\n      flex-grow: 1;\n      border-radius: 0;\n      border-width: 0;\n      border-top: var(--bs-popover-border-width) solid var(--bs-popover-border-color) !important;\n      + .btn {\n        border-left: var(--bs-popover-border-width) solid var(--bs-popover-border-color) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
